import api from "services/api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Get role permissions
export const getRoles = async () => {
  return api.get("/v1/api/get-role-permissions");
};

// create role permissions
export const createRole = async (rolePermissionData) => {
  return api.post("/v1/api/assign-role-permissions", rolePermissionData);
};
